import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const TimeOutThree = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={pdfFiles.strategiesPart1[5]}
        vidSrc={927766087}
      />
    </div>
  );
};

export default TimeOutThree;
